export const SIDEBAR_ITEMS = [
  {
    label: 'sidebar.editProfile',
    icon: 'heroUser',
    routerLink: ['/profile'],
  },
  {
    label: 'sidebar.reportIncident',
    icon: 'heroExclamationTriangle',
    routerLink: ['/report-incident'],
  },
  {
    label: 'sidebar.viewReportedIncidents',
    icon: 'heroClipboardDocumentList',
    routerLink: ['/reports'],
  },
];
